import { render, staticRenderFns } from "./SickLeaveBalanceDetails.vue?vue&type=template&id=486b6cba&scoped=true&"
import script from "./SickLeaveBalanceDetails.vue?vue&type=script&lang=ts&"
export * from "./SickLeaveBalanceDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486b6cba",
  null
  
)

export default component.exports